import React from 'react';
import {
  buttonFactory,
  StyledButton,
  ButtonProps,
  StyledButtonProps,
} from './button';
import Loader from './loader';

const StyledSubmitButton = StyledButton.withComponent('button');
const RawSubmitButton: React.FunctionComponent<
  StyledButtonProps &
    React.DetailedHTMLProps<
      React.ButtonHTMLAttributes<HTMLButtonElement>,
      HTMLButtonElement
    >
> =
  buttonFactory<React.ComponentProps<typeof StyledSubmitButton>>(
    StyledSubmitButton,
  );

type Props = ButtonProps<React.ComponentProps<typeof RawSubmitButton>> & {
  loading?: boolean;
  children?: React.ReactNode;
};

const SubmitButton = ({ loading, children, ...props }: Props) => (
  <RawSubmitButton type="submit" {...props}>
    {loading ? <Loader size={20} /> : children}
  </RawSubmitButton>
);

export default SubmitButton;
